import { MobileSkeletonLoader } from '@/components/atoms/MobileSkeletonLoader/MobileSkeletonLoader'
import { MobileBlockHeader } from '@/components/molecules/MobileBlockHeader/MobileBlockHeader'
import { TransactionData } from '@/features/Transactions/transactions.types'
import { MobileTxRow } from '@/features/Transactions/ui/MobileTxRow/MobileTxRow'
import { MobileEventRow } from '@/features/Events/ui/MobileEventRow/MobileEventRow'
import { Options } from '@splidejs/splide'
import { Button, Flex } from 'antd'
import { useRouter } from 'nextjs-toploader/app'
import React from 'react'
import { Splide, SplideSlide } from '@splidejs/react-splide'
import classnames from 'classnames'
import styles from './MobileTransactionsList.module.scss'
import '@splidejs/react-splide/css'

type Props = {
  blockExtraLink: string;
  blockExtraTitle: string;
  blockTitle: string;
  transactions: TransactionData[];
  direction?: 'vertical' | 'horizontal';
  events?: any[];
  withPadding?: boolean;
}

const sliderOptions: Options = {
  arrows: false,
  pagination: false,
  waitForTransition: true,
  perPage: 1,
  perMove: 1,
  speed: 500,
  direction: 'ltr',
  padding: 16,
  gap: 8,
  wheel: true,
  wheelSleep: 300,
}

export function MobileTransactionsList({
  transactions,
  blockTitle,
  blockExtraTitle,
  blockExtraLink,
  events,
  direction = 'horizontal',
  withPadding,
}: Props) {
  const router = useRouter()

  if (!transactions) {
    return <MobileSkeletonLoader height="78px" width="100%" withTitle />
  }

  return (
    <div className={classnames((direction === 'horizontal') && styles.root)}>
      <MobileBlockHeader
        title={blockTitle}
        viewAllTitle={blockExtraTitle}
        link={blockExtraLink}
        withMargin={direction === 'horizontal'}
      />

      {transactions.length === 0 && (
        <div className={classnames(direction === 'horizontal' && styles.empty, withPadding && styles.emptyNoPadding, direction === 'vertical' && styles.empty)}>
          You dont have any transactions yet
        </div>
      )}

      {transactions.length > 0 && (
        direction === 'horizontal' ? (
          <div>
            <Splide
              aria-label={`${blockTitle} list`}
              options={sliderOptions}
            >
              {events && events.map((event) => (
                <SplideSlide key={event.text}><MobileEventRow type={event.type} text={event.text} /></SplideSlide>
              ))}
              {transactions.map((transaction) => (
                <SplideSlide key={transaction.id}>
                  <MobileTxRow transaction={transaction} />
                </SplideSlide>
              ))}
              <SplideSlide key="view-all-k">
                <Button onClick={() => router.push(blockExtraLink)} className={styles.viewAllButton}>
                  <i>👀</i>
                  See more
                </Button>
              </SplideSlide>
            </Splide>
          </div>
        ) : (
          <Flex vertical gap={8}>
            {transactions.map((transaction) => (
              <MobileTxRow key={transaction.id} transaction={transaction} />
            ))}
          </Flex>
        )
      )}
    </div>
  )
}
